module.exports = __webpack_public_path__ + "static/media/NOR.f53cd07d.png";